<template>
  <div class="changelog presentations">
    <div>
      <div>
        <table v-if="log.length">
          <thead>
            <tr>
              <th>{{ _.date }}</th>
              <th>{{ _.user }}</th>
              <th>{{ _.action }}</th>
              <th>{{ _.presentation }}</th>
              <th>{{ _.order }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lval, lkey) in log" :key="lkey">
              <td style="white-space:nowrap">
                {{ time(lval.date) }}
              </td>
              <td>
                {{ user(lval.user_id) }}
              </td>
              <td>
                {{ action(lval.action) }}
              </td>
              <td>
                <span v-html="presentation(lval.presentation_id)"></span>
              </td>
              <td>
                {{ lval.order }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      users: [],
      presentations: [],
      log: [],
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      return (this.users && this.users[id]) ? this.users[id] : 'System';
    },
    action(action) {
      if (action === 'create') action = 'Add';
      if (action === 'update') action = 'Change';
      if (action === 'delete') action = 'Remove';
      return action;
    },
    presentation(id) {
      if (this.presentations && this.presentations[id]) {
        let presentation = this.presentations[id]['title'];
        if (this.presentations[id]['code']) presentation = this.presentations[id]['code'] + ' ' + presentation;
        return presentation;
      }
      return '';
    },
  },
  async created() {
    dayjs.extend(utc);
    const log = await this.axios.get(API_URL + '/logs/sessions/' + this.$route.params.id + '/presentations');
    this.users = log.data.users;
    this.presentations = log.data.presentations;
    this.log = log.data.log;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.changelog.presentations {
  position: absolute;
  top: 0;
  right: 0;
  width: 680px;
  height: 100%;
  opacity: .95;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    overflow-y: scroll;
    > div {
      margin: 12px;
      > table {
        border: none;
        border-collapse: collapse;
        border-spacing: none;
        width: 100%;
        > thead {
          > tr {
            > th {
              text-align: left;
              font-weight: normal;
              padding: .125rem .5rem .125rem 0;
              opacity: 0.4;
            }
          }
        }
        > tbody {
          > tr {
            > td {
              padding: .125rem .5rem .125rem 0;
              vertical-align: top;
            }
          }
        }
      }
    }
  }
}
</style>
